import React from "react";
import { Link } from "react-router-dom";
import { Select } from "antd";

import CollapseHeader from "../../../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../../../router/all_routes";

export interface CompanySelectOption {
  value: string;
  label: string;
  companyId: string | number;
  companyType: string;
}

interface AttendanceAdminHeaderProps {
  companies: CompanySelectOption[];
  activeCompanyKey: string | null;
  companiesLoading: boolean;
  exportDisabled?: boolean;
  payrollDisabled?: boolean;
  onCompanyChange: (company: CompanySelectOption) => void;
  onExportClick: () => void;
  onPayrollClick: () => void;
}

const filterOption = (input: string, option?: { label: string; value: any }) =>
  (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());

const AttendanceAdminHeader: React.FC<AttendanceAdminHeaderProps> = ({
  companies,
  activeCompanyKey,
  companiesLoading,
  exportDisabled = false,
  payrollDisabled = false,
  onCompanyChange,
  onExportClick,
  onPayrollClick,
}) => {
  const handleSelect = (value: string) => {
    const match = companies.find((c) => c.value === value);
    if (match) onCompanyChange(match);
  };

  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1" style={{ fontSize: 22, fontWeight: 600, color: "#0f172a" }}>
          Attendance
        </h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={all_routes.adminDashboard}>
                <i className="ti ti-smart-home" />
              </Link>
            </li>
            <li className="breadcrumb-item">Attendance</li>
            <li className="breadcrumb-item active" aria-current="page">
              Admin
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
        <Select
          showSearch
          filterOption={filterOption}
          style={{ width: 260, minHeight: 38 }}
          placeholder="Select Company"
          value={activeCompanyKey || undefined}
          loading={companiesLoading}
          onChange={handleSelect}
          options={companies.map((c) => ({ value: c.value, label: c.label }))}
        />
        <button
          type="button"
          className="btn btn-success d-inline-flex align-items-center"
          onClick={onExportClick}
          disabled={exportDisabled}
          style={{ minHeight: 38 }}
        >
          <i className="ti ti-download me-1" />
          Export
        </button>
        <button
          type="button"
          className="btn btn-info d-inline-flex align-items-center"
          onClick={onPayrollClick}
          disabled={payrollDisabled}
          style={{ minHeight: 38 }}
        >
          <i className="ti ti-file-spreadsheet me-1" />
          Payroll Report
        </button>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="head-icons mb-0">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceAdminHeader;
